export const servicesEnum = {
  91: 'Parcel Ship to Shop',
  11: 'Two day Parcel',
  12: 'Parcel Next Day',
  13: 'Parcel By 12',
  '08': 'Parcel By 10:30',
  8: 'Parcel By 10:30',
  71: 'Parcel Saturday',
  17: 'Parcel Sat By 12',
  75: 'Parcel Sunday',
  15: 'Parcel Sun By 12',
  19: 'Parcel - DPD Europe By Road',
  60: 'Air Classic',
  50: 'Air Express',
  20: 'DPD Direct Lite',
};
